import React, {useContext, useEffect, useState} from 'react'
import {Badge, Button, Card, Col, Form, ProgressBar, Row, Spinner} from "react-bootstrap";
import PromptModal from "./PromptModal";
import {
    COMPLETED,
    FAILED,
    RESPONSE_SUCCESSFUL,
    UNKNOWN,
    UPGRADE_INFO_ERROR_MESSAGE,
    UPGRADE_PROGRESS_ERROR_MESSAGE,
    UPGRADE_START_ERROR_MESSAGE,
    UPGRADING,
    WARNING,
    SUCCESS,
    DANGER,
    STATUS_PROGRESSING,
    STATUS_FAILED,
    STATUS_SUCCEEDED,
    STATUS_STARTED,
    UPGRADE_LATEST_OS_PROMPT,
    UPGRADE_OS_PROMPT,
    STARTED,
    UPGRADE_PERCENTAGE_INTERVAL,
    UPGRADE_STATUS_POLLING_INTERVAL,
    NOT_AVAILABLE,
    NOT_FOUND
} from "./Types";
import UpgradeTerminal from "./UpgradeTerminal";
import {PackageService} from "./PackageService"
import moment from "moment/moment";
import {getCurrentAuthToken} from "../../General/SharedMethods";
import {NativeEventSource, EventSourcePolyfill} from 'event-source-polyfill';
import {SET_CU_CURRENT_VERSION, SET_CU_NEWEST_VERSION, SET_CU_UPDATE_DATE, SET_EDIT_MODE} from "../../Store/ActionTypes/General/actionTypes";
import {store} from "../../Store/store";
import {PackageNameService} from "./PackageNameService";


export default function UpgradePage({
                                        controlUnitId
                                    }) {
    const [promptMessage, setPromptMessage] = useState(null);
    const [showModal, setShowModal] = useState(null);
    const [isUpgradeRequestInProgress, setIsUpgradeRequestInProgress] = useState(false);
    const [isFetchUpgradeInfoInProgress, setIsFetchUpgradeInfoInProgress] = useState(true);
    const [isUpgradeInProgress, setIsUpgradeInProgress] = useState(false);
    const [lastLog, setLastLog] = useState(null);
    const [logsExpanded, setLogsExpanded] = useState(false);
    const [upgradeStatus, setUpgradeStatus] = useState('');
    const [badgeColor, setBadgeColor] = useState('');
    const [progressPercentage, setProgressPercentage] = useState(0);
    const [installedVersion, setInstalledVersion] = useState(null);
    const [latestVersion, setLatestVersion] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [showError, setShowError] = useState(false);
    const [upgradeInfoErrorOccurred, setUpgradeInfoErrorOccurred] = useState(false);
    const [upgradeProgressInfoErrorOccurred, setUpgradeProgressInfoErrorOccurred] = useState(false);
    const [lastStatusUpdate, setLastStatusUpdate] = useState(null);
    const [packageName, setPackageName] = useState(null);
    const [packageService, setPackageService] = useState(null);
    const [upgradeProgressInterval, setUpgradeProgressInterval] = useState(null);
    const [upgradeButtonPressed, setUpgradeButtonPressed] = useState(false);
    const [sseRequestId, setSseRequestId] = useState(null);
    const packageNameService = new PackageNameService(process.env.REACT_APP_SUPPORT_DASHBOARD_WINT_PACKAGE_SERVICE_URL);
    const {dispatch} = useContext(store);

    const getCurrentNameAndVersion = async () => {
        try {
            const response = await packageNameService.getPackageNameAndVersion(controlUnitId);
            setInstalledVersion(response.data.version);
            setPackageName(response.data.packageName);
            dispatch({
                type: SET_CU_CURRENT_VERSION, payload: response.data.version
            });
        } catch (e) {
            console.error(e);
            setUpgradeInfoErrorOccurred(true);
            setIsFetchUpgradeInfoInProgress(false);
        }
    }

    const fetchUpgradeData = async () => {
        setShowError(false);
        await getUpgradeStatus();
        await getLatestVersion();
        setIsFetchUpgradeInfoInProgress(false);
    };


    const getLatestVersion = async () => {
        try {
            const response = await packageService.getLatestUpgradeVersion();
            setLatestVersion(response.data.version);
            dispatch({
                type: SET_CU_NEWEST_VERSION, payload: response.data.version
            });
        } catch (e) {
            console.error(e);
            setUpgradeInfoErrorOccurred(true);
        }
    }

    const getUpgradeStatus = async () => {
        try {
            setUpgradeInfoErrorOccurred(false);
            const response = await packageService.getUpgradeStatus(controlUnitId);
            const status = response.data.status;
            const updated = moment(response.data.updated).format('lll');
            dispatch({
                type: SET_CU_UPDATE_DATE, payload: updated
            });
            setLastStatusUpdate(updated);
            switch (status) {
                case STATUS_STARTED: {
                    setUpgradeStatus(STARTED);
                    setBadgeColor(WARNING);
                    break;
                }
                case STATUS_PROGRESSING: {
                    setSseRequestId(response.data.requestId);
                    setUpgradeStatus(UPGRADING);
                    setBadgeColor(WARNING);
                    break;
                }
                case STATUS_SUCCEEDED: {
                    setUpgradeStatus(COMPLETED);
                    setBadgeColor(SUCCESS);
                    break;
                }
                case STATUS_FAILED: {
                    if (response.data.reason) {
                        setErrorMessage(response.data.reason);
                        setShowError(true);
                    }
                    setUpgradeStatus(FAILED);
                    setBadgeColor(DANGER);
                    break;
                }
                default: {
                    setUpgradeStatus(UNKNOWN);
                    setBadgeColor(WARNING);
                }
            }
        } catch (e) {
            setUpgradeStatus(UNKNOWN);
            setBadgeColor(WARNING);
            if (e.response?.status === NOT_FOUND) {
                setUpgradeInfoErrorOccurred(false);
                setShowError(false);
                return;
            }
            setUpgradeInfoErrorOccurred(true);
        }
    }


    const handleUpgradeDevice = async () => {
        try {
            setUpgradeButtonPressed(true);
            setErrorMessage(null);
            setShowError(false);
            setIsUpgradeRequestInProgress(true);
            const response = await packageService.upgradeDevice(controlUnitId);
            setIsUpgradeRequestInProgress(false);
            if (response.data.reason && !response.data.started) {
                setErrorMessage(response.data.reason);
                setShowError(true);
            }
            setShowModal(false);
        } catch (e) {
            console.error(e);
            setIsUpgradeRequestInProgress(false);
            setErrorMessage(UPGRADE_START_ERROR_MESSAGE);
            setShowError(true);

        }
    }

    const versionsEqual = () => {
        if (installedVersion === null || latestVersion === null) {
            return false;
        }
        return installedVersion === latestVersion
    }

    useEffect(() => {
        getCurrentNameAndVersion()
    }, []);

    useEffect(() => {
        if (packageName) {
            const newPackageService = new PackageService(process.env.REACT_APP_SUPPORT_DASHBOARD_WINT_PACKAGE_SERVICE_URL, packageName);
            setPackageService(newPackageService);
        }
    }, [packageName]);


    useEffect(() => {
            if (packageService) {
                fetchUpgradeData();
            }
        },
        [packageService])

    useEffect(() => {
        if (packageService) {
            const interval = setInterval(async () => {
                await getUpgradeStatus();
            }, UPGRADE_STATUS_POLLING_INTERVAL);
            return () => {
                clearInterval(interval);
            };
        }
    }, [packageService]);

    useEffect(() => {
        if (progressPercentage === 100) {
            setProgressPercentage(0);
        }
    }, [progressPercentage])


    useEffect(() => {
        if (!isFetchUpgradeInfoInProgress && upgradeInfoErrorOccurred) {
            if (!errorMessage) {
                setErrorMessage(UPGRADE_INFO_ERROR_MESSAGE);
            }
            setShowError(true);
        }
        if (!isFetchUpgradeInfoInProgress && upgradeProgressInfoErrorOccurred) {
            if (!errorMessage) {
                setErrorMessage(UPGRADE_PROGRESS_ERROR_MESSAGE);
            }
            setShowError(true);
        }
    }, [isFetchUpgradeInfoInProgress, upgradeInfoErrorOccurred, upgradeProgressInfoErrorOccurred])

    useEffect(() => {
        if (sseRequestId) {
            const authHeaderValue = getCurrentAuthToken();
            const eventSourceInitDict = {
                headers: {
                    'Authorization': authHeaderValue
                }
            };
            const EventSource = NativeEventSource && NativeEventSource.supportsHeaders ? NativeEventSource : EventSourcePolyfill;
            const eventSource = new EventSource(`${process.env.REACT_APP_SUPPORT_DASHBOARD_WINT_PACKAGE_SERVICE_URL}/api/packages/v0/device/upgrade/${sseRequestId}/logs/stream`, eventSourceInitDict);
            eventSource.onmessage = (event) => {
                setUpgradeProgressInfoErrorOccurred(false);
                let dataString = '';
                JSON.parse(event.data).forEach((line) => {
                    dataString += line + '\n\r';
                })
                setLastLog(dataString);
            };

            eventSource.onerror = (error) => {
                console.error('EventSource failed:', error);
                eventSource.close();
            };

            return () => {
                eventSource.close();
            };
        }
    }, [sseRequestId]);

    useEffect(() => {
        if (upgradeStatus === COMPLETED || upgradeStatus === FAILED || upgradeStatus === UPGRADING) {
            try {
                packageService.getUpgradeProgress(controlUnitId).then((response) => {
                    if (response.status === RESPONSE_SUCCESSFUL) {
                        setLastLog(response.data);
                    }
                });
            } catch (e) {
                console.error(e);
                setUpgradeProgressInfoErrorOccurred(true);
            }
        }
    }, [upgradeStatus])

    useEffect(() => {
        if (upgradeStatus === UPGRADING) {
            setIsUpgradeInProgress(true);
            const interval = setInterval(() => {
                setProgressPercentage((prevPrec) => prevPrec + 1);
            }, UPGRADE_PERCENTAGE_INTERVAL);
            setUpgradeProgressInterval(interval);
        } else {
            getCurrentNameAndVersion();
            clearInterval(upgradeProgressInterval);
            setIsUpgradeInProgress(false);
            setProgressPercentage(0);
        }
        return () => {
            clearInterval(upgradeProgressInterval);
        };
    }, [upgradeStatus]);

    useEffect(() => {
        if (upgradeButtonPressed) {
            setTimeout(function () {
                setUpgradeButtonPressed(false);
            }, 10000);
        }
    }, [upgradeButtonPressed])


    useEffect(() => {
        return () => {
            dispatch({
                type: SET_CU_CURRENT_VERSION, payload: null
            });
            dispatch({
                type: SET_CU_NEWEST_VERSION, payload: null
            });
            dispatch({
                type: SET_CU_UPDATE_DATE, payload: null
            });
        };
    }, []);


    {
        return (
            <>
                <PromptModal handlePrompt={handleUpgradeDevice}
                             showError={false}
                             show={showModal} setShow={setShowModal}
                             promptMessage={promptMessage}/>
                <Row style={{marginRight: '230px'}} className={'mb-2'}>
                    <Col md={logsExpanded ? {span: 10, offset: 2} : {span: 9, offset: 3}}>
                        <Card bsPrefix='tabCard'>
                            <Card.Body>
                                {isFetchUpgradeInfoInProgress ?
                                    <Spinner animation='border' variant='primary' size='md'/> :
                                    <div style={{display: "flex", justifyContent: 'space-between'}}>
                                        <div>
                                            <div style={{display: 'flex', justifyContent: 'start'}}>
                                                <div className='d-inline'>
                                                    <strong className='mr-2'>Last Update Status:</strong>
                                                </div>
                                                <div className='d-inline'>
                                                    {
                                                        upgradeStatus ?
                                                            <Badge variant={badgeColor}
                                                                   style={{margin: 0}}>{upgradeStatus}</Badge> :
                                                            <div className='d-inline'>{NOT_AVAILABLE}</div>
                                                    }
                                                </div>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'start'}}>
                                                <div className='d-inline'>
                                                    <strong className='mr-2'>Last Status Update At:</strong>
                                                </div>
                                                <div className='d-inline'>
                                                    {lastStatusUpdate ? lastStatusUpdate : NOT_AVAILABLE}
                                                </div>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'start'}}>
                                                <div className='d-inline'>
                                                    <strong className='mr-2'>Installed Package Version:</strong>
                                                </div>
                                                <div className='d-inline'>
                                                    {installedVersion ? installedVersion : NOT_AVAILABLE}
                                                </div>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'start'}}>
                                                <div className='d-inline'>
                                                    <strong className='mr-2'>Latest Package Version:</strong>
                                                </div>
                                                <div className='d-inline'>
                                                    {latestVersion ? latestVersion : NOT_AVAILABLE}
                                                </div>
                                            </div>
                                        </div>
                                        <Col md={7} className='mt-2 pl-0'>
                                            {
                                                isUpgradeInProgress ?
                                                    <ProgressBar style={{height: 25}} animated now={progressPercentage}
                                                                 label={`${progressPercentage}%`}/>
                                                    :
                                                    null
                                            }
                                        </Col>
                                        <div>
                                            <div className='d-inline mr-5'>
                                                <Button
                                                    disabled={isUpgradeRequestInProgress || isUpgradeInProgress || upgradeStatus === STARTED || upgradeButtonPressed}
                                                    onClick={() => {
                                                        versionsEqual() ? setPromptMessage(UPGRADE_LATEST_OS_PROMPT) :
                                                            setPromptMessage(UPGRADE_OS_PROMPT);
                                                        setShowModal(true)
                                                    }
                                                    }>{isUpgradeInProgress ? "Upgrading..." : "Start"}</Button>
                                            </div>
                                            <div className='d-inline'>
                                                {
                                                    upgradeStatus === COMPLETED || upgradeStatus === FAILED || isUpgradeInProgress ?
                                                        <Form.Check className='mt-3'
                                                                    checked={logsExpanded}
                                                                    type="switch"
                                                                    id="custom-switch"
                                                                    label="Show Logs"
                                                                    onClick={() => setLogsExpanded(!logsExpanded)}
                                                        />
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                {showError ? <div className='upgradeError'>
                                        <div style={{textAlign: "center"}}>Error:</div>
                                        <div> {`We apologize for the inconvenience, but ${errorMessage}.`}</div>
                                    </div>
                                    : null}
                                {logsExpanded ?
                                    <Row noGutters className="justify-content-center mt-3">
                                        <Col md={12}>
                                            <UpgradeTerminal lastLog={lastLog} setLastLog={setLastLog}/>
                                        </Col>
                                    </Row>
                                    : null
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </>
        )
    }
}
